<template>
  <svg width="36" height="36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="18.25" cy="18.47" r="17.5" fill="#fff" fill-opacity=".9"/>
    <path transform="matrix(.73596 .67702 -.73596 .67702 10.5 12.9722)" stroke="#5300BB" stroke-width="2" stroke-linecap="round" d="M1-1h18.3814"/>
    <path transform="matrix(.73596 -.67702 -.73596 -.67702 10.5 25.5696)" stroke="#5300BB" stroke-width="2" stroke-linecap="round" d="M1-1h18.3814"/>
  </svg>
</template>